// admin-usersService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const adminUsersApi = axios.create({
  baseURL: `${API_URL}/api/v1/admin`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token
adminUsersApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
adminUsersApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

const adminUserService = {
  // Get users with filters
  getUsers: async (params = {}) => {
    const response = await adminUsersApi.get('/users', { params });
    return response.data;
  },

  // Get user by ID
  getUserById: async (userId) => {
    const response = await adminUsersApi.get(`/users/${userId}`);
    return response.data;
  },

  // Get user orders
  getUserOrders: async (userId, params = {}) => {
    const response = await adminUsersApi.get(`/users/${userId}/orders`, { params });
    return response.data;
  },

  // Get user future gifts
  getUserFutureGifts: async (userId, params = {}) => {
    const response = await adminUsersApi.get(`/users/${userId}/future-gifts`, { params });
    return response.data;
  },

  // Update user status
  updateUserStatus: async (userId, status, reason = '') => {
    const response = await adminUsersApi.patch(`/users/${userId}/status`, { status, reason });
    return response.data;
  },

  // Add internal note to user
  addUserNote: async (userId, note) => {
    const response = await adminUsersApi.post(`/users/${userId}/notes`, { note });
    return response.data;
  },

  // Get user statistics
  getUserStats: async () => {
    const response = await adminUsersApi.get('/users/stats');
    return response.data;
  },

  

  // Search users
  searchUsers: async (query, params = {}) => {
    const response = await adminUsersApi.get('/users/search', { 
      params: { ...params, query } 
    });
    return response.data;
  }
};

export default adminUserService;